import { render, staticRenderFns } from "./ModalUpdateSpecimen.vue?vue&type=template&id=d52142e2"
import script from "./ModalUpdateSpecimen.vue?vue&type=script&lang=js"
export * from "./ModalUpdateSpecimen.vue?vue&type=script&lang=js"
import style0 from "./ModalUpdateSpecimen.vue?vue&type=style&index=0&id=d52142e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports